import request from "./../utils/request";

export const LEAD_API = {
    listForms: async (filters, cursor, sort) => {
        return request.post(
            "/meta/forms",
            { filters, cursor, sort },
            {
                timeout: 60 * 1000 * 5,
            }
        );
    },
    distinctAdFilters: async () => {
        return request.get("/meta/distinct-ad-filters", {
            timeout: 60 * 1000 * 5,
        });
    },
};
